<template>
    <div>

        <div id="contact" class="section bg-svg-rainoverforest2">
            <div class="overlay opacity-50"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-10">Thanks!</h1>
                        <p class="lead mb-10">Please check your email for instructions on how to get free access to our Sleep Sounds Premium features. We'll also send you occasional emails about new sounds, recommendations, and announcements.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'insider-success',
        metaInfo: {
            title: 'Insider Success'
        },
        data () {
            return {
            };
        },
        methods: {
        },
        computed: {
        },
        components: {
        },
        mounted(){
        }
    }
</script>
